import { decorImages } from "../data/content";
import { useContent } from "../context/ContentContext";
import { resolveAsset } from "../lib/api";

export const Historia = () => {
  const { content } = useContent();
  return (
  <section id="historia" data-testid="historia-section" className="section-anchor bg-[#081A4D]/60 backdrop-blur-[2px] py-24 lg:py-32">
    <div className="max-w-6xl mx-auto px-5 sm:px-8">
      <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#8AB0FF] mb-4 reveal">Mi Historia</p>
      <h2 className="font-serif-display text-3xl sm:text-4xl font-semibold text-white mb-12 reveal">
        {content.historiaHeading}
      </h2>

      <div className="grid lg:grid-cols-[2fr_1fr] gap-12 items-start">
        <div className="space-y-6">
          {(content.biography || []).map((p, i) => (
            <p key={i} data-testid={`bio-paragraph-${i}`} className="text-base sm:text-lg text-neutral-200 leading-relaxed reveal">
              {p}
            </p>
          ))}
        </div>

        <div className="space-y-6">
          {content.photos?.historia && (
            <img
              data-testid="historia-photo"
              src={resolveAsset(content.photos.historia)}
              alt="Yosimar de Paz"
              className="w-full rounded-2xl border border-[#C0C7D1]/60 shadow-lg reveal"
            />
          )}
          <div className="rounded-2xl overflow-hidden border border-[#C0C7D1]/60 reveal">
            <img
              src={decorImages.studio}
              alt="Estudio de radio, imagen decorativa"
              className="w-full h-56 object-cover opacity-80"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};
